import jquery from "./lib/jquery.min.js";

export default ((window as any).$ = (window as any).jQuery = jquery);